// src/pages/projects/projectAccess.js
//
// WHY THIS FILE EXISTS:
// Every project page (Detail, Checklist, Documents, Materials) must answer
// the same question: "may this user open this project?" A company_id match
// alone is not enough — field roles may only open projects they are
// assigned to. Keeping the rule in ONE place stops the four pages drifting
// apart (D-287 found Detail/List had no assignment check at all, and
// Checklist/Documents/Materials were still open by direct URL).
//
// Rules:
//   sm / owner / manager -> any project in their company
//   site_engineer        -> only if listed in project.site_engineer_ids
//   technician           -> only if they have a service job on the project
//                           (same rule ProjectList uses)
//   any other role       -> no access (App.js has no project routes for them)

import { fetchProjectsForTechnician } from "./projectService";

export const MANAGER_ROLES = ["sm", "owner", "manager"];

export const isManagerRole = (role) => MANAGER_ROLES.includes(role);

// projectData: the project doc's data; projectId: its doc id;
// user: the logged-in user object from localStorage.
export async function canAccessProject(projectData, projectId, user) {
  if (!projectData || !user) return false;
  if (projectData.company_id !== (user.company_id || "")) return false;

  const role  = user.role || "";
  const myUid = user.uid || user.id;

  if (isManagerRole(role)) return true;

  if (role === "site_engineer") {
    return (projectData.site_engineer_ids || []).includes(myUid);
  }

  if (role === "technician") {
    const myProjects = await fetchProjectsForTechnician(projectData.company_id, myUid);
    return myProjects.some(p => p.id === projectId);
  }

  return false;
}